import { render, staticRenderFns } from "./PreviewJobTabForSp.vue?vue&type=template&id=4498c284&scoped=true"
var script = {}
import style0 from "./PreviewJobTabForSp.vue?vue&type=style&index=0&id=4498c284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498c284",
  null
  
)

export default component.exports